import qs from 'qs';
import { ADMIN_ENDPOINT } from 'src/constants/api';

import { baseApi } from './base';


export type UserUpdate = Omit<User, 'role' | 'accounts'> & { role: number };
type AdminUpdate = {
  email: string;
  first_name: string;
  last_name: string;
  role: number;
  username: string;
};

const profileApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProfilePictureUrl: builder.mutation({
      query: (data: FormData) => ({
        url: 'users/avatar',
        method: 'POST',
        body: data,
      })
    }),
    changePassword: builder.mutation({
      query: ({current_password, new_password}: {current_password: string, new_password: string}) => ({
        url: 'auth/change-password',
        method: 'POST',
        body: { current_password, new_password},
      })
    }),
    updateUser: builder.mutation({
      query: ({userId, newUser, password}: {userId: number, newUser: UserUpdate | FormData, password?: string}) => {
        //@ts-ignore
        delete newUser.last_login;
        //@ts-ignore
        delete newUser.last_activity_at;
        //@ts-ignore
        delete newUser.countries;

        const form = new FormData();

        Object.keys(newUser).map(field => {
          //@ts-ignore
          form.append(field, newUser[field]);
        });

        if (password) {
          form.append('password', password);
        }

        return {
          url: `xuser/${userId}`,
          method: 'POST',
          body: form
        };
      }
    }),
    getUser: builder.mutation({
      query: (userId: number) => {
        return {
          url: `users/${userId}`,
          method: 'GET'
        };
      },
    }),
    getAdminUsers: builder.mutation({
      query: (page: number) => {
        const params = { page, per_page: 100 };
        return `${ADMIN_ENDPOINT}/users?${qs.stringify(params)}`;
      },
    }),
    updateAdminUser: builder.mutation({
      query: ({userId, newUser, password} : {userId: number, newUser: AdminUpdate, password?: string}) => {
        //@ts-ignore
        delete newUser.last_login;
        //@ts-ignore
        delete newUser.last_activity_at;
        
        return {
          url: `${ADMIN_ENDPOINT}/users/${userId}`,
          method: 'PUT',
          body: {...newUser, ...(password && {password})},
        }
      }
    }),
  })
});

export const {
  useGetProfilePictureUrlMutation,
  useChangePasswordMutation,
  useUpdateUserMutation,
  useGetAdminUsersMutation,
  useUpdateAdminUserMutation,
  useGetUserMutation
} = profileApi;
